import React from 'react';
import {Link} from 'react-router-dom';
import '../styles/Footer.css';

export default function Footer(){
  const isHome=true;

  const footerLink={
    color:'#bfbfbf',
    textDecoration:'none'
  };

  return(

    <footer
      className={isHome ? "axu-home-footer" : undefined}
      style={{
        marginTop:'80px',
        background:'#050505',
        borderTop:'1px solid rgba(127,0,255,.25)',
        color:'#fff'
      }}
    >

      <div
        style={{
          maxWidth:'1200px',
          margin:'0 auto',
          padding:'60px 30px',
          display:'grid',
          gridTemplateColumns:'repeat(auto-fit,minmax(250px,1fr))',
          gap:'50px'
        }}
      >

        <div>

          <h2
            style={{
              color:'#00ffff',
              marginBottom:'20px'
            }}
          >
            AXU Workforce
          </h2>

          <p
            style={{
              color:'#bfbfbf',
              lineHeight:'1.8'
            }}
          >
            AXU Workforce supplies reliable temporary and permanent workers
            to employers across the United Kingdom.
          </p>

        </div>

        <div>

          <h3
            style={{
              marginBottom:'20px'
            }}
          >
            Quick Links
          </h3>

          <div
            style={{
              display:'flex',
              flexDirection:'column',
              gap:'12px'
            }}
          >

            <Link to="/" style={footerLink}>
              Home
            </Link>

            <Link to="/services" style={footerLink}>
              Services
            </Link>

            <Link to="/quote" style={footerLink}>
              Register for Work
            </Link>

            <Link to="/employer" style={footerLink}>
              Employers
            </Link>

            <Link to="/contact" style={footerLink}>
              Contact
            </Link>

          </div>

        </div>

        <div>

          <h3
            style={{
              marginBottom:'20px'
            }}
          >
            Contact
          </h3>

          <p
            style={{
              color:'#bfbfbf',
              lineHeight:'1.8'
            }}
          >
            Email
            <br/>
            <a href="mailto:info@axuworkforce.co.uk" style={footerLink}>info@axuworkforce.co.uk</a>
          </p>

          <p
            style={{
              color:'#bfbfbf',
              marginTop:'20px'
            }}
          >
            United Kingdom
          </p>

        </div>

        <div>

          <h3
            style={{
              marginBottom:'20px'
            }}
          >
            Legal
          </h3>

          <div
            style={{
              display:'flex',
              flexDirection:'column',
              gap:'12px'
            }}
          >

            <Link
              to="/privacy"
              style={footerLink}
            >
              Privacy Policy
            </Link>

            <Link
              to="/terms"
              style={footerLink}
            >
              Terms & Conditions
            </Link>

          </div>

        </div>

      </div>

      <div
        style={{
          borderTop:'1px solid rgba(255,255,255,.08)',
          textAlign:'center',
          padding:'25px',
          color:'#888'
        }}
      >
        © {new Date().getFullYear()} AXU Workforce. All Rights Reserved.
      </div>

    </footer>

  );

}